import * as THREE from "three";
import Experience from "../Experience.js";

export default class TestObject {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("TestObject");
    }

    this.setGeometry();
    this.setMaterial();
    this.setMesh();
  }

  setGeometry() {
    this.geometry = new THREE.SphereGeometry(0.02, 50);
  }

  setMaterial() {
    this.material = new THREE.MeshStandardMaterial({ color: "red" });
  }

  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.set(1.37, -0.37, 0.52);
    this.scene.add(this.mesh);
    
    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.mesh.position, "x")
        .name("x")
        .min(0)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.mesh.position, "y")
        .name("y")
        .min(-10)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.mesh.position, "z")
        .name("z")
        .min(0)
        .max(10)
        .step(0.1);
    }
  }
}
